import { jsx as _jsx } from "react/jsx-runtime";
import { AppText, Spinner, styled, Theme } from '@streem/ui-react';
const CallDetailsAppText = styled(AppText)(({ isTrayOpen }) => ({
    marginRight: '12px',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    breakWord: 'break-all',
    overflow: 'hidden',
    [`@media ${Theme.mediaBreakpoints.small}`]: {
        maxWidth: isTrayOpen ? '62px' : '102px',
    },
}));
export const RemoteUserName = ({ remoteUser, isTrayOpen }) => {
    return remoteUser ? (_jsx(CallDetailsAppText, { isTrayOpen: isTrayOpen, color: "dark", children: remoteUser.name })) : (_jsx(Spinner, { size: "20px", color: Theme.colors.azure }));
};
//# sourceMappingURL=remote_user_name.js.map